/* ============================================================
   OpticalH — Scroll-triggered reveal animations
   Uses IntersectionObserver to add .oh-visible class
   when elements enter the viewport.
   v3 — Progressive Enhancement: adds .oh-will-animate first,
         so elements are visible by default if JS fails.
   ============================================================ */
(function(){
  'use strict';


  /* OH_COLLECTION_FILTER_NATIVE_BUTTONS_V2
     Promote the editorial filter proxies to native controls before the V1
     state/keyboard enhancer binds them. This keeps the radio/CSS contract but
     avoids role=button labels in Safari/VoiceOver. */
  function installNativeCollectionFilterControls(){
    var styleId='oh-collection-filter-native-controls-v2';
    if(!document.getElementById(styleId)){
      var style=document.createElement('style');
      style.id=styleId;
      style.textContent=''
        + '.oh-collection-filter__trigger,.oh-collection-filter__close{-webkit-appearance:none;appearance:none;font-family:inherit;}'
        + '.oh-collection-filter__close{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;flex:0 0 44px!important;padding:0!important;border:0!important;border-radius:12px!important;}'
        + '.oh-collection-filter__panel .oh-collection-nav__link{min-height:44px!important;padding:9px 10px!important;border-radius:12px!important;}'
        + '.oh-collection-filter__trigger:focus-visible,.oh-collection-filter__close:focus-visible,.oh-collection-filter__panel .oh-collection-nav__link:focus-visible{outline:2px solid #1666c7!important;outline-offset:2px!important;}'
        + 'body.template-collection product-list{max-width:100%;min-width:0;overflow-x:clip;}'
        + '@media (forced-colors:active){.oh-collection-filter__trigger,.oh-collection-filter__close,.oh-collection-filter__panel .oh-collection-nav__link{border:1px solid ButtonText!important;}}';
      (document.head||document.documentElement).appendChild(style);
    }

    function promote(label){
      if(!label || label.tagName==='BUTTON') return label;
      var button=document.createElement('button');
      Array.prototype.slice.call(label.attributes).forEach(function(attribute){
        if(attribute.name!=='for' && attribute.name!=='role' && attribute.name!=='tabindex'){
          button.setAttribute(attribute.name,attribute.value);
        }
      });
      button.type='button';
      while(label.firstChild) button.appendChild(label.firstChild);
      label.parentNode.replaceChild(button,label);
      return button;
    }

    document.querySelectorAll('.oh-collection-filter').forEach(function(root){
      if(root.getAttribute('data-oh-native-filter-buttons')!=='true'){
        Array.prototype.slice.call(root.querySelectorAll('label.oh-collection-filter__trigger,label.oh-collection-filter__close')).forEach(promote);
        root.setAttribute('data-oh-native-filter-buttons','true');
      }
      if(root.getAttribute('data-oh-accessible-filter')==='true') return;

      var controls=Array.prototype.slice.call(root.querySelectorAll('.oh-collection-filter__control'));
      var triggers=Array.prototype.slice.call(root.querySelectorAll('.oh-collection-filter__trigger'));
      var panels=Array.prototype.slice.call(root.querySelectorAll('.oh-collection-filter__panel'));
      var closeControl=controls[0];
      if(!closeControl || !triggers.length || triggers.length!==panels.length || controls.length<triggers.length+1) return;

      root.setAttribute('data-oh-accessible-filter','true');
      controls.forEach(function(control){
        control.tabIndex=-1;
        control.setAttribute('aria-hidden','true');
      });

      function sync(){
        triggers.forEach(function(trigger,index){
          var control=controls[index+1];
          var panel=panels[index];
          var open=Boolean(control && control.checked);
          trigger.setAttribute('aria-expanded',open?'true':'false');
          panel.setAttribute('aria-hidden',open?'false':'true');
          if(open) panel.removeAttribute('inert');
          else panel.setAttribute('inert','');
        });
      }

      function choose(control){
        if(!control) return;
        control.checked=true;
        control.dispatchEvent(new Event('change',{bubbles:true}));
      }

      triggers.forEach(function(trigger,index){
        var control=controls[index+1];
        var panel=panels[index];
        var close=panel.querySelector('.oh-collection-filter__close');
        var panelId=panel.id || ((control && control.id) ? control.id+'-panel' : 'oh-filter-panel-'+index);
        panel.id=panelId;
        trigger.setAttribute('aria-controls',panelId);

        trigger.addEventListener('click',function(event){
          event.preventDefault();
          choose(control && control.checked ? closeControl : control);
        });
        trigger.addEventListener('keydown',function(event){
          if(event.key==='Enter' || event.key===' '){
            event.preventDefault();
            trigger.click();
          }
        });

        if(close){
          close.setAttribute('aria-controls',panelId);
          close.addEventListener('click',function(event){
            event.preventDefault();
            trigger.focus({preventScroll:true});
            choose(closeControl);
          });
          close.addEventListener('keydown',function(event){
            if(event.key==='Enter' || event.key===' '){
              event.preventDefault();
              close.click();
            }
          });
        }

        panel.addEventListener('keydown',function(event){
          if(event.key==='Escape'){
            event.preventDefault();
            trigger.focus({preventScroll:true});
            choose(closeControl);
          }
        });
      });

      /* OH_COLLECTION_FILTER_ESCAPE_SCOPE_V3
         Escape is handled at the filter root because opening a disclosure
         intentionally leaves focus on its trigger. A panel-only listener can
         never observe Escape in that valid state. */
      root.addEventListener('keydown',function(event){
        if(event.key!=='Escape' || !root.contains(event.target)) return;
        var openIndex=-1;
        triggers.some(function(trigger,index){
          if(trigger.getAttribute('aria-expanded')==='true'){
            openIndex=index;
            return true;
          }
          return false;
        });
        if(openIndex<0) return;
        event.preventDefault();
        event.stopPropagation();
        choose(closeControl);
        sync();
        try{ triggers[openIndex].focus({preventScroll:true}); }
        catch(error){ triggers[openIndex].focus(); }
      },true);

      controls.forEach(function(control){ control.addEventListener('change',sync); });
      sync();
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',installNativeCollectionFilterControls);
  }else{
    installNativeCollectionFilterControls();
  }
  document.addEventListener('shopify:section:load',installNativeCollectionFilterControls);
  var SEL = '.oh-nav-section, .oh-seo-text, .oh-faq, .oh-gender-tabs';

  if(!('IntersectionObserver' in window)) {
    return;
  }

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('oh-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.01,
    rootMargin: '0px 0px -20px 0px'
  });

  function init(){
    var targets = document.querySelectorAll(SEL);
    targets.forEach(function(el){
      el.classList.add('oh-will-animate');
      observer.observe(el);
    });
    setTimeout(fallback, 3000);
  }

  function fallback(){
    var vh = window.innerHeight;
    document.querySelectorAll(SEL).forEach(function(el){
      if(el.classList.contains('oh-will-animate') && !el.classList.contains('oh-visible')){
        var rect = el.getBoundingClientRect();
        if(rect.top < vh + 100){
          el.classList.add('oh-visible');
        }
      }
    });
  }

  var scrollTimer;
  function onScroll(){
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(fallback, 150);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      init();
      window.addEventListener('scroll', onScroll, {passive: true});
    });
  } else {
    init();
    window.addEventListener('scroll', onScroll, {passive: true});
  }

  /* Fix: Add title to Zendesk chat iframe for accessibility */
  function fixIframeTitles() {
    var frames = document.querySelectorAll('iframe:not([title])');
    frames.forEach(function(f) {
      if (f.id === 'web-messenger-container' || f.src && f.src.indexOf('zendesk') !== -1) {
        f.setAttribute('title', 'Chat de soporte');
      } else if (!f.title) {
        f.setAttribute('title', 'Contenido integrado');
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(fixIframeTitles, 2000); });
  } else {
    setTimeout(fixIframeTitles, 2000);
  }
  /* Re-check periodically for dynamically injected iframes */
  var iframeObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.tagName === 'IFRAME' && !n.title) {
          fixIframeTitles();
        }
      });
    });
  });
  iframeObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });


  /* OH_COLLECTION_FILTER_ACCESSIBILITY_V1
     The editorial filter HTML lives in collection descriptions. Enhance it
     without changing its URLs, CSS radio state or visual composition. */
  function initAccessibleCollectionFilters(){
    document.querySelectorAll('.oh-collection-filter').forEach(function(root){
      if(root.getAttribute('data-oh-accessible-filter')==='true') return;

      var controls=Array.prototype.slice.call(root.querySelectorAll('.oh-collection-filter__control'));
      var triggers=Array.prototype.slice.call(root.querySelectorAll('.oh-collection-filter__trigger'));
      var panels=Array.prototype.slice.call(root.querySelectorAll('.oh-collection-filter__panel'));
      var closeControl=controls[0];
      if(!closeControl || !triggers.length || triggers.length!==panels.length || controls.length<triggers.length+1) return;

      root.setAttribute('data-oh-accessible-filter','true');
      controls.forEach(function(control){
        control.tabIndex=-1;
        control.setAttribute('aria-hidden','true');
      });

      function sync(){
        triggers.forEach(function(trigger,index){
          var control=controls[index+1];
          var panel=panels[index];
          var open=Boolean(control && control.checked);
          trigger.setAttribute('aria-expanded',open?'true':'false');
          panel.setAttribute('aria-hidden',open?'false':'true');
          if(open){
            panel.removeAttribute('inert');
          }else{
            panel.setAttribute('inert','');
          }
        });
      }

      function choose(control){
        if(!control) return;
        control.checked=true;
        control.dispatchEvent(new Event('change',{bubbles:true}));
      }

      triggers.forEach(function(trigger,index){
        var control=controls[index+1];
        var panel=panels[index];
        var close=panel.querySelector('.oh-collection-filter__close');
        var panelId=panel.id || ((control && control.id) ? control.id+'-panel' : 'oh-filter-panel-'+index);

        panel.id=panelId;
        trigger.setAttribute('role','button');
        trigger.setAttribute('tabindex','0');
        trigger.setAttribute('aria-controls',panelId);

        trigger.addEventListener('click',function(event){
          event.preventDefault();
          choose(control && control.checked ? closeControl : control);
        });
        trigger.addEventListener('keydown',function(event){
          if(event.key==='Enter' || event.key===' '){
            event.preventDefault();
            trigger.click();
          }
        });

        if(close){
          close.setAttribute('role','button');
          close.setAttribute('tabindex','0');
          close.setAttribute('aria-controls',panelId);
          close.addEventListener('click',function(event){
            event.preventDefault();
            trigger.focus({preventScroll:true});
            choose(closeControl);
          });
          close.addEventListener('keydown',function(event){
            if(event.key==='Enter' || event.key===' '){
              event.preventDefault();
              close.click();
            }
          });
        }

        panel.addEventListener('keydown',function(event){
          if(event.key==='Escape'){
            event.preventDefault();
            trigger.focus({preventScroll:true});
            choose(closeControl);
          }
        });
      });

      controls.forEach(function(control){ control.addEventListener('change',sync); });
      sync();
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initAccessibleCollectionFilters);
  }else{
    initAccessibleCollectionFilters();
  }

})();